import React, { useContext } from "react";
import { Box, Stack, useTheme } from "@mui/material";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import StatusField from "@/modules/lead-page/new/components/header/status-field";
import Stepper from "@/modules/common/components/ui-kit/stepper/stepper";
import ArchivedOverlay from "@/modules/common/components/ui-kit/archived-overlay";

const LeadHeader: React.FC = () => {
  const theme = useTheme();
  const { isMobile } = useScreenSize();
  const { lead, stages } = useContext(LeadPageContext);

  // const currentStageId = lead?.data?.lead?.status?.statusCategory?.stageId;
  // const funnelStages = lead?.data?.lead_type?.funnel?.stageMappings || [];
  // const shouldShowStepper = funnelStages.length > 0 && currentStageId;
  // const leadType = lead?.data?.lead_type?.lead_type;
  // const leadId = lead?.data?.nanoId;

  // Check if lead is archived
  const isArchived = lead?.data?.lead?.archived === true;

  return (
    <Box>
      {/* First Row */}
      {isMobile && (
        <Stack
          sx={{
            bgcolor: theme.nawy.colors.semantic.layer.primary,
            borderRadius: "12px",
            width: "100%",
            maxWidth: isMobile ? "100vw" : "100%",
            overflow: "hidden",
          }}
        >
          {/* Mobile Second Row - Title/Status and Actions */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            sx={{
              maxWidth: "100%",
              width: "100%",
              overflow: "hidden",
            }}
            padding={theme.nawy.spacing.md}
          >
            <Stack
              spacing={theme.nawy.spacing.xs}
              sx={{
                flex: 1,
                minWidth: 0,
                maxWidth: "100%",
                width: "100%",
                overflow: "hidden",
              }}
              alignContent="center"
              gap={theme.nawy.spacing.md}
            >
              {stages?.data && stages.data.length > 0 && (
                <ArchivedOverlay isArchived={isArchived}>
                  <Box
                    sx={{
                      textAlign: "center",
                      color: theme.nawy.colors.semantic.text.secondary,
                      width: "100%",
                      maxWidth: "100%",
                      overflow: "hidden",
                      justifyContent: "center",
                      minWidth: 0,
                    }}
                  >
                    <Stepper stepsData={stages} />
                  </Box>
                </ArchivedOverlay>
              )}

              <Box
                sx={{
                  flex: 1,
                  minWidth: 0,
                  width: "100%",
                  maxWidth: "100%",
                  alignSelf: "center",
                }}
              >
                <StatusField />
              </Box>
            </Stack>
          </Stack>
        </Stack>
      )}
    </Box>
  );
};

export default LeadHeader;
